import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import CatalogPage from './pages/CatalogPage/CatalogPage';
import ContactsPage from './pages/ContactsPage/ContactsPage';
import ErrorPage from './pages/ErrorPage/ErrorPage';
import Layout from './components/Layout/Layout';
import CookieConsent from 'react-cookie-consent';
import './App.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/catalogo',
        element: <CatalogPage />,
      },
      {
        path: '/contatti',
        element: <ContactsPage />,
      }
    ],
  },
]);

const App = () => {

  return (
    <div className="app-container">
      <RouterProvider router={router} />
      <CookieConsent
        location="bottom"
        buttonText="Accetto"
        declineButtonText="Rifiuto"
        cookieName="userConsent"
        style={{ background: "#2B373B", color: "white" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
      >
        Questo sito utilizza i cookie per migliorare la tua esperienza di navigazione.{" "}
      </CookieConsent>
    </div>
  );
  
};

export default App;
